import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MobileMenuProvider } from './components/overall_manager/contexts/MobileMenuContext';
import MobileOverlay from './components/overall_manager/layouts/MobileOverlay';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './components/overall_manager/screens/Dashboard';
import Companies from './components/overall_manager/screens/Companies';
import CreateCompany from './components/overall_manager/screens/CreateCompany';
import CreateAdminManager from './components/overall_manager/screens/CreateAdminManager';
import AdminManagers from './components/overall_manager/screens/AdminManagers';
import AdminDashboard from './components/admin_manager/screens/AdminDashboard';
import Employees from './components/admin_manager/screens/Employees';   
import CreateHrManager from './components/admin_manager/screens/CreateHrManager';
import Login from './components/auth/Login';
import CreateDepartment from './components/admin_manager/screens/CreateDepartment';
import Departments from './components/admin_manager/screens/Departments';
import CreateEmployee from './components/admin_manager/screens/CreateEmployee';
import UpdateEmployee from './components/admin_manager/screens/UpdateEmployee';
import CreateNotice from './components/admin_manager/screens/CreateNotice';
import Notices from './components/admin_manager/screens/Notices';
import ChangePassword from './components/admin_manager/screens/ChangePassword';
import Profile from './components/admin_manager/screens/Profile';
import EmployeeDashboard from './components/regular_employee/screens/EmployeeDashboard';
import BulkEmployeeCreation from './components/admin_manager/screens/BulkEmployeeCreation';
import ManagerDashboard from './components/hr_manager/screens/ManagerDashboard';
import ManagerEmployees from './components/hr_manager/screens/ManagerEmployees';
import ManagerNotices from './components/hr_manager/screens/ManagerNotices';
import ManagerProfile from './components/hr_manager/screens/ManagerProfile';
import ManagerChangePassword from './components/hr_manager/screens/ManagerChangePassword';
import LeaveRequest from './components/regular_employee/screens/LeaveRequest';
import LeaveApplications from './components/hr_manager/screens/LeaveApplications';
import LeaveHistory from './components/regular_employee/screens/LeaveHistory';
import EmployeeNotices from './components/regular_employee/screens/EmployeeNotices';
import PasswordReset from './components/auth/PasswordReset';
import LoanRequest from './components/regular_employee/screens/LoanRequest';
import LoanRequests from './components/hr_manager/screens/LoanRequests';
import LoanHistory from './components/regular_employee/screens/LoanHistory';
import EmployeeChangePassword from './components/regular_employee/screens/EmployeeChangePassword';
import EmployeeProfile from './components/regular_employee/screens/EmployeeProfile';
import ManagerCreateNotice from './components/hr_manager/screens/ManagerCreateNotice';
import Activities from './components/admin_manager/screens/Activities';
import ManagerActivities from './components/hr_manager/screens/ManagerActivities';
import ManagerApplyLeave from './components/hr_manager/screens/ManagerApplyLeave';
import ManagerLeaveRequests from './components/hr_manager/screens/ManagerLeaveRequests';
import ExEmployees from './components/admin_manager/screens/ExEmployees';
import DisciplinaryRecords from './components/admin_manager/screens/DisciplinaryRecords';

function App() {
  return (
    <BrowserRouter>
      <MobileMenuProvider>
        <MobileOverlay />

        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/reset-password/:uid/:token" element={<PasswordReset />} />

          {/* Overall Manager Routes */}
          <Route path="/overall-manager/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/companies/add" element={
            <ProtectedRoute>
              <CreateCompany />
            </ProtectedRoute>
          } />
          <Route path="/companies/view" element={
            <ProtectedRoute>
              <Companies />
            </ProtectedRoute>
          } />
          <Route path="/admin-managers/add" element={
            <ProtectedRoute>
              <CreateAdminManager />
            </ProtectedRoute>
          } />
          <Route path="/admin-managers/view" element={
            <ProtectedRoute>
              <AdminManagers />
            </ProtectedRoute>
          } />

          {/* Company Manager Routes */}
          <Route path="/admin-manager/dashboard" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin-manager/employees" element={
            <ProtectedRoute>
              <Employees />
            </ProtectedRoute>
          } />
          <Route path="/admin-manager/add-department" element={
            <ProtectedRoute>
              <CreateDepartment />
            </ProtectedRoute>
          } />
          <Route path="/admin-manager/departments" element={
            <ProtectedRoute>
              <Departments />
            </ProtectedRoute>
          } />
          <Route path="/admin-manager/add-hr-manager" element={
            <ProtectedRoute>
              <CreateHrManager />
            </ProtectedRoute>
          } />
          <Route path="/admin-manager/add-employee" element={
            <ProtectedRoute>
              <CreateEmployee />
            </ProtectedRoute>
          } />
          <Route path="/admin-manager/update-employee/:id" element={
            <ProtectedRoute>
              <UpdateEmployee />
            </ProtectedRoute>
          } />
          <Route path="/admin-manager/notices/create" element={
            <ProtectedRoute>
              <CreateNotice />
            </ProtectedRoute>
          } />
          <Route path="/admin-manager/notices" element={
            <ProtectedRoute>
              <Notices />
            </ProtectedRoute>
          } />
          <Route path="/admin-manager/change-password" element={
            <ProtectedRoute>
              <ChangePassword />
            </ProtectedRoute>
          } />
          <Route path="/admin-manager/profile" element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          } />
          <Route path="/admin-manager/bulk-employee-creation" element={
            <ProtectedRoute>
              <BulkEmployeeCreation />
            </ProtectedRoute>
          } />
          <Route path="/admin-manager/activities" element={
            <ProtectedRoute>
              <Activities />
            </ProtectedRoute>
          } />

          <Route path="admin-manager/ex-employees" element={
            <ProtectedRoute>
              <ExEmployees/>
            </ProtectedRoute>
          } />

          <Route path="admin-manager/disciplinary-records" element={
            <ProtectedRoute>
              <DisciplinaryRecords/>
            </ProtectedRoute>
          } />

          {/* Human Resource Manager Routes */}
          <Route path="/manager/dashboard" element={
            <ProtectedRoute>
              <ManagerDashboard />
            </ProtectedRoute>
          } />
          <Route path="/manager/employees" element={
            <ProtectedRoute>
              <ManagerEmployees />
            </ProtectedRoute>
          } />
          <Route path="/manager/notices" element={
            <ProtectedRoute>
              <ManagerNotices />
            </ProtectedRoute>
          } />
          <Route path="/manager/profile" element={
            <ProtectedRoute>
              <ManagerProfile />
            </ProtectedRoute>
          } />
          <Route path="/manager/change-password" element={
            <ProtectedRoute>
              <ManagerChangePassword />
            </ProtectedRoute>
          } />
          <Route path="/manager/create-notice" element={
            <ProtectedRoute>
              <ManagerCreateNotice />
            </ProtectedRoute>
          } />
          <Route path="/manager/activities" element={
            <ProtectedRoute>
              <ManagerActivities />
            </ProtectedRoute>
          } />
          <Route path="/manager/leave-requests" element={
            <ProtectedRoute>
              <LeaveApplications />
            </ProtectedRoute>
          } />
          <Route path="/manager/loan-requests" element={
            <ProtectedRoute>
              <LoanRequests />
            </ProtectedRoute>
          } />
          <Route path="/manager/apply-leave" element={
            <ProtectedRoute>
              <ManagerApplyLeave />
            </ProtectedRoute>
          } />

          <Route path="/manager/leave-history" element={
            <ProtectedRoute>
              <ManagerLeaveRequests />
            </ProtectedRoute>
          } />
          

          {/* Employee Routes */}
          <Route path="/employee/dashboard" element={
            <ProtectedRoute>
              <EmployeeDashboard />
            </ProtectedRoute>
          } />
          <Route path="/employee/profile" element={
            <ProtectedRoute>
              <EmployeeProfile />
            </ProtectedRoute>
          } />
          <Route path="/employee/apply-leave" element={
            <ProtectedRoute>
              <LeaveRequest />
            </ProtectedRoute>
          } />
          <Route path="/employee/leave-history" element={
            <ProtectedRoute>
              <LeaveHistory />
            </ProtectedRoute>
          } />
          <Route path="/employee/notices" element={
            <ProtectedRoute>
              <EmployeeNotices />
            </ProtectedRoute>
          } />
          <Route path="/employee/loan-request" element={
            <ProtectedRoute>
              <LoanRequest />
            </ProtectedRoute>
          } />
          <Route path="/employee/loan-history" element={
            <ProtectedRoute>
              <LoanHistory />
            </ProtectedRoute>
          } />
          <Route path="/employee/change-password" element={
            <ProtectedRoute>
              <EmployeeChangePassword />
            </ProtectedRoute>
          } />
        </Routes>
      </MobileMenuProvider>
    </BrowserRouter>
  );
}

export default App;
